/* eslint-disable prettier/prettier */
import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr
} from "@chakra-ui/react";

import { ExtractionSummary } from "@/jenesys-types/jenesys-entities/config";

import { formatNumberWithThousandsSeparator } from "@/util/helpers";

interface CompaniesReportProps {
  summary?: ExtractionSummary;
}

export const CompaniesReport: React.FC<CompaniesReportProps> = ({
  summary
}) => (
  <TableContainer>
    <Table variant="unstyled" size="sm">
      <Thead>
        <Tr>
          <Th
            color="blackAlpha.700"
            textTransform="capitalize"
            fontWeight={500}
          >
            Company
          </Th>
          <Th
            color="blackAlpha.700"
            textTransform="capitalize"
            fontWeight={500}
          >
            Processed Invoices
          </Th>
          <Th
            color="blackAlpha.700"
            textTransform="capitalize"
            fontWeight={500}
            isNumeric
          >
            Billable Amount (GBP)
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        {summary?.detailed_company_summary?.map((company) => (
          <Tr key={company.company_id}>
            <Td fontWeight={500} py={3}>
              {company.company_name}
            </Td>
            <Td fontWeight={500} py={3}>
              {company.processed}
            </Td>
            <Td fontWeight={500} py={3} isNumeric>
              {company?.billable_amount
                ? formatNumberWithThousandsSeparator(company.billable_amount)
                : 0}
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  </TableContainer>
);
